export default __webpack_public_path__ + "static/media/ARTIST-05-(1-2).8301f738.jpg";